import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Home } from './pages/Home';
import { BrandDetail } from './pages/BrandDetail';
import { ModelDetail } from './pages/ModelDetail';
import { Contact } from './pages/Contact';
import { FAB, ActionSheet } from './components';
import { useConfig } from './hooks/useApi';

/**
 * 旧的 4 级商品页 → 3 级型号页的兜底跳转。
 *
 * 为什么保留这条路由：老链接可能已经发在 Viber 群里，直接 404 会让客户
 * 以为站点坏了；重定向到型号页，图片和价格照样能看到。
 */
function LegacyColorRedirect() {
  const { brandId, modelId } = useParams<{ brandId: string; modelId: string }>();
  return <Navigate to={`/brand/${brandId}/model/${modelId}`} replace />;
}

export default function App() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const config = useConfig();

  const openSheet = () => setSheetOpen(true);
  const closeSheet = () => setSheetOpen(false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home onContact={openSheet} />} />
        <Route path="/brand/:brandId" element={<BrandDetail />} />
        <Route path="/brand/:brandId/model/:modelId" element={<ModelDetail onContact={openSheet} />} />
        {/* 3 级化之后不再有商品详情页；旧链接重定向，保住已发出去的地址 */}
        <Route path="/brand/:brandId/model/:modelId/color/:code" element={<LegacyColorRedirect />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* FAB - only shows on home (handled internally) */}
      <FAB onClick={openSheet} />

      {/* Action Sheet - global */}
      {sheetOpen && <ActionSheet config={config} onClose={closeSheet} />}
    </BrowserRouter>
  );
}
